class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    if (!this.details || !this.summary) return;

    this.onFocusOut = this.onFocusOut.bind(this);
    this.addEventListener('focusout', this.onFocusOut);
  }

  onFocusOut() {
    window.setTimeout(() => {
      if (!this.contains(document.activeElement) && this.details) {
        this.details.removeAttribute('open');
      }
    });
  }
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}
